import React, { useState, useEffect } from 'react';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { captcha_key } from './constants';
const CaptchaV3 = (props) => {
    const { onVerify, token, refreshReCaptcha, type } = props;
    // const [siteKey, setSiteKey] = useState(null);
    // useEffect(() => {
    //     // Simulate asynchronous loading of the site key
    //     const loadSiteKey = async () => {
    //         try {
    //             // Fetch the site key from an API or environment variable
    //             let url = window.url + '/api/resource/recaptchaKey';
    //             const response = await fetch(url);
    //             const data = await response.json();
    //             if (data && data.key) {
    //                 setSiteKey(data.key);
    //             }
    //         } catch (error) {
    //             console.error('Error loading reCAPTCHA site key:', error);
    //         }
    //     };

    //     loadSiteKey();
    // }, []);
    // console.log("siteKey", siteKey);
    return (
        <>
            {
                captcha_key &&
                <GoogleReCaptchaProvider reCaptchaKey={captcha_key}>
                    {
                        !token &&

                        <GoogleReCaptcha
                            onVerify={onVerify}
                            refreshReCaptcha={refreshReCaptcha}
                        />
                    }
                </GoogleReCaptchaProvider>
            }
        </>

    )
}

export default CaptchaV3;


